/* GOD FIRST CLOTHING — Theme JS */

// ── Scroll-based header ──
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function onScroll() {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── Fade-up on scroll ──
(function() {
  var els = document.querySelectorAll('.fade-up');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function(el) { obs.observe(el); });
})();

// ── Mobile menu toggle ──
(function() {
  var btn = document.querySelector('.mobile-menu-btn');
  var menu = document.querySelector('.mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', function() {
    var open = menu.classList.toggle('open');
    document.body.style.overflow = open ? 'hidden' : '';
    btn.setAttribute('aria-expanded', open);
  });
  // Close on link click
  menu.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      menu.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
})();

// ── Quantity selector ──
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.qty-btn');
  if (!btn) return;
  var input = btn.closest('.qty-input').querySelector('.qty-num');
  if (!input) return;
  var val = parseInt(input.value) || 1;
  if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
  if (btn.dataset.action === 'plus') val = val + 1;
  input.value = val;
});

// ── Add to cart (Shopify AJAX) ──
document.addEventListener('submit', function(e) {
  var form = e.target.closest('.product-form');
  if (!form) return;
  e.preventDefault();
  var btn = form.querySelector('.btn-add-to-cart');
  var originalText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

  var data = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: data
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (btn) { btn.textContent = 'Added!'; }
    // Update cart count
    return fetch('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var count = document.querySelector('.cart-count');
    if (count) { count.textContent = cart.item_count; count.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
    setTimeout(function() {
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    }, 2000);
  })
  .catch(function() {
    if (btn) { btn.textContent = 'Error — try again'; btn.disabled = false; }
  });
});
